const AUTH_KEYS = ['token', 'userId', 'isAdmin'];

const getStorageWithToken = () => {
  if (localStorage.getItem('token')) {
    return localStorage;
  }

  if (sessionStorage.getItem('token')) {
    return sessionStorage;
  }

  return null;
};

export const getAuthToken = () => getStorageWithToken()?.getItem('token') || null;

export const getStoredAuth = () => {
  const storage = getStorageWithToken();

  return {
    token: storage?.getItem('token') || null,
    userId: storage?.getItem('userId') || null,
    isAdmin: storage?.getItem('isAdmin') === 'true',
  };
};

export const storeAuth = ({ token, userId, isAdmin, rememberMe }) => {
  const storage = rememberMe ? localStorage : sessionStorage;
  const otherStorage = rememberMe ? sessionStorage : localStorage;

  AUTH_KEYS.forEach((key) => otherStorage.removeItem(key));

  storage.setItem('token', token);
  storage.setItem('userId', userId);
  storage.setItem('isAdmin', isAdmin ? 'true' : 'false');
};

export const clearAuth = () => {
  [localStorage, sessionStorage].forEach((storage) => {
    AUTH_KEYS.forEach((key) => storage.removeItem(key));
  });
};
